@if (statusItem) {
    <div class="wk-sm__status__header">
        <div class="wk-sm__status__header-title" kendoTooltip title="" position="bottom" (mouseover)="showTooltip($event)">
            {{ statusItem.TaxReturnStatuse?.Name | wkTranslate }}
            @if (!statusItem.TaxReturnStatuse?.Active) {
                @if (statusItem.TaxReturnStatuse) {
                    {{ "General.Inactive" | wkTranslate }}
                } @else {
                    {{ "General.Deleted" | wkTranslate }}
                }
            }
        </div>
        @if (statusItem.TaxReturnStatuse && statusItem.TaxReturnStatuse.TaxAppStatusId >= 100 && statusItem.TaxReturnStatuse.TaxAppStatusId <= 104) {
            <div class="wk-sm__status__header__actions">
                <div class="wk-sm__status__header__actions-edit">
                    <wk-icon-pencil-sprite-pds3 />
                    <icon-pds3 name="wk-icon-pencil" (click)="editStep()" />
                </div>
            </div>
        }
    </div>
    @if (!isJobsBillingDashboard) {
        <select-field-pds3 cg3-theme="PDS-v3" size="medium" label="">
            <select [(ngModel)]="statusItem.RoleId" (ngModelChange)="this.onFormChanged.emit(true)">
                @for (role of roles; track role.Id) {
                    <option [ngValue]="role.Id">{{ role.Description | wkTranslate }}</option>
                }
            </select>
        </select-field-pds3>
    }
}
